export function Skeleton({ className = '' }) {
  return <div className={`animate-pulse bg-white/5 rounded-md ${className}`} />
}

export function SkeletonRow({ count = 3 }) {
  return (
    <div className="space-y-2">
      {Array.from({ length: count }).map((_, i) => (
        <Skeleton key={i} className="h-10 w-full" />
      ))}
    </div>
  )
}
